import React from 'react';
export function ProblemSection() {
  const painPoints = ['Leíste sobre Montessori, pero no sabés cómo aplicarlo en casa', 'Probaste consejos de redes que no se sostienen', 'Sabés lo que no querés hacer… pero no qué hacer en su lugar', 'Querés hacerlo mejor sin exigirte ser perfecto/a'];
  return <section className="w-full bg-[#F5EDE4] py-16 px-4" data-id="element-208">
      <div className="max-w-3xl mx-auto" data-id="element-209">
        <h2 className="text-2xl sm:text-3xl font-bold text-[#5C4033] mb-4 text-center" data-id="element-210">
          El problema que nadie dice en voz alta
        </h2>

        <p className="text-lg text-[#8B7355] mb-4 text-center" data-id="element-211">
          Hoy hay demasiada información y poca claridad real.
        </p>
        <p className="text-lg text-[#8B7355] mb-8 text-center font-medium" data-id="element-212">
          Probablemente te pasó:
        </p>

        <ul className="space-y-4 mb-10" data-id="element-213">
          {painPoints.map((point, index) => <li key={index} className="flex items-start gap-3" data-id="element-214">
              <span className="flex-shrink-0 w-6 h-6 bg-[#FDE8E4] text-[#C4645A] rounded-full flex items-center justify-center text-sm font-bold" data-id="element-215">
                ✗
              </span>
              <span className="text-lg text-[#8B7355]" data-id="element-216">{point}</span>
            </li>)}
        </ul>

        <div className="bg-[#FDF8F3] rounded-xl p-6 border-l-4 border-[#C4645A] shadow-sm" data-id="element-217">
          <p className="text-lg text-[#5C4033] italic text-center font-medium" data-id="element-218">
            Y aparece esa pregunta silenciosa:
            <br data-id="element-219" />
            <span className="font-bold text-xl block mt-2" data-id="element-220">
              "¿Cómo crío con respeto sin perderme yo en el intento?"
            </span>
          </p>
        </div>
      </div>
    </section>;
}